import { Card, CardHeader } from "ui/components/card";
import { Button } from "ui/components/button";
import { Icon } from ".";
import { LINK } from "icons/src";
import { useNavigate } from "react-router-dom";

export default function IntegrationsCard({ title, icon, link, href }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  const handleCardClick = () => {
    if (!href) return;
    if (href.startsWith("/")) {
      navigate(href);
    } else {
      window.open(href, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Card
      className={
        href ? "cursor-pointer hover:bg-accent/50 transition-colors" : ""
      }
      onClick={href ? handleCardClick : undefined}
    >
      <CardHeader className="px-6">
        <div className="flex items-center gap-2">
          <div className="text-foreground flex h-8 w-8 items-center justify-center">
            <Icon icon={icon} className="size-8" />
          </div>
          <h3 className="text-card-foreground flex-1 font-semibold">{title}</h3>
          <Button variant="ghost" size="icon" onClick={handleClick}>
            <Icon icon={LINK} className="size-4" />
          </Button>
        </div>
      </CardHeader>
    </Card>
  );
}
